export const GET_USER = "GET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const LOAD_START = "LOAD_START";
export const LOAD_END = "LOAD_END";
export const SET_ERROR = "SET_ERROR";
